import { render, staticRenderFns } from "./candidate-list.vue?vue&type=template&id=0b43f866"
import script from "./candidate-list.vue?vue&type=script&lang=js"
export * from "./candidate-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports